// src/DBTPieChart.js
import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DBTPieChart({ phoneTypes, state }) {
  if (!phoneTypes || !Object.keys(phoneTypes).length) {
    return <div className="no-data">No phone type data for {state}</div>;
  }

  const labels = Object.keys(phoneTypes);
  const dataValues = Object.values(phoneTypes).map((v) => v * 100);

  const data = {
    labels,
    datasets: [
      {
        label: "% of Phone Types",
        data: dataValues,
        backgroundColor: [
          "#2563eb",
          "#60a5fa",
          "#93c5fd",
          "#bfdbfe",
          "#dbeafe",
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="purpose-pie">
      <h3>{state} – Phone Type Distribution</h3>
      <Pie data={data} />
    </div>
  );
}
